export const API_URLS = {
    AUTH: {
        LOGIN: `/api/auth/login`,
        LOGOUT: `/api/auth/logout`,
        ME: `/api/auth/me`,
        UTILS: '/api/auth/utils',
        ACCEPT_TERMS: `/api/auth/accept-terms`,
        REGISTER: `/api/auth/register`,
    },
    AFFILIATE: {
        BALANCE: '/api/affiliates/balance',
        SUBSCRIBE: '/api/subscribers',
        PUT: (id) => `/api/affiliate/${id}`,
    },
    ADDRESS: {
        GET: '/api/addresses/show',
        POST: '/api/addresses',
        ZIPCODE: '/api/zipcode',
    },
    BANKS: {
        GET: '/api/banks',
        ACCOUNTS_SHOW: '/api/bankAccounts/show',
        ACCOUNTS: '/api/bankAccounts',
        ACCOUNTS_PUT: (id) => `/api/bankAccounts/${id}`,
    },
    MERCHANTS: {
        GET: '/api/merchants',
    },
    PASSWORD: {
        RESET: '/api/reset-password',
        CREATE: '/api/create-password',
        UPDATE: '/api/affiliates/update-password',
    },
    PAYMENT: {
        GET: '/api/payment',
        POST: '/api/payment',
    },
    QUALIFICATION: {
        AFFILIATE: `/api/qualification/affiliate`,
        SPECIALIST: `/api/qualification/specialist`,
        DEVELOPER: `/api/qualification/developer`,
    },
    REPORTS: {
        ACTIVATION_REVENUE: '/api/reports/payment-affiliate/activationRevenue',
        TOTAL_COMMISSION: '/api/reports/payment-affiliate/totalComission',
        RECURRING_REVENUE: '/api/reports/payment-affiliate/recurringRevenue',
        REGISTRATION: '/api/reports/payment-affiliate/registrations',
        ANALYTICAL_REGISTRATION: '/api/reports/payment-affiliate/analyticalRegistrations',
    },
    SPECIALIST: {
        POST: '/api/specialist-lead',
    },
    REWARDS: {
        GET: '/api/rewards',
    },
    VERIFY_CODE: {
        GET: `/api/auth/request-verify`,
        POST: `/api/auth/verify`,
    },
    SURVEYS: {
        GET: '/api/surveys',
        POST: (alias) => `/api/surveys/${alias}/confirm`,
    },
};
